import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BadgeCheck, MapPin, Building2 } from "lucide-react";
import api, { API } from "@/lib/api";

function DistributorCard({ d, index }) {
  const [logoOk, setLogoOk] = useState(d.has_logo);
  return (
    <div className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5 transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:shadow-lg animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }} data-testid={`authorized-dist-${d.id}`}>
      <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center overflow-hidden rounded-xl border border-border bg-white">
        {logoOk ? <img src={`${API}/public/distributors/${d.id}/logo`} alt={d.company} className="h-full w-full object-contain p-1" loading="lazy" onError={() => setLogoOk(false)} />
          : <Building2 className="h-7 w-7 text-muted-foreground" />}
      </div>
      <div className="min-w-0">
        <p className="truncate font-display text-base font-bold tracking-tight">{d.company}</p>
        <p className="mt-1 flex items-center gap-1 text-sm text-muted-foreground"><MapPin className="h-3.5 w-3.5 text-primary" />{d.state || "México"}</p>
        <p className="mt-1 flex items-center gap-1 text-xs font-medium text-[hsl(var(--success))]"><BadgeCheck className="h-3.5 w-3.5" /> Distribuidor autorizado</p>
      </div>
    </div>
  );
}

export function AuthorizedDistributors() {
  const [items, setItems] = useState(null);
  const [state, setState] = useState("all");
  useEffect(() => { api.get("/public/distributors").then(({ data }) => setItems(data.distributors)).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  const states = [...new Set(items.map((d) => d.state).filter(Boolean))].sort();
  const shown = state === "all" ? items : items.filter((d) => d.state === state);
  return (
    <section id="autorizados" className="border-t border-border bg-secondary/40" data-testid="authorized-distributors-section">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-8">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <p className="overline text-primary">Red oficial</p>
            <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight md:text-5xl">Distribuidores autorizados</h2>
            <p className="mt-4 text-muted-foreground">Encuentra un distribuidor cerca de ti para instalar, configurar y capacitarte en ProfesionalPOS.</p>
          </div>
          <Select value={state} onValueChange={setState}>
            <SelectTrigger className="w-full sm:w-64" data-testid="authorized-state-filter"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos los estados</SelectItem>
              {states.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {shown.map((d, i) => <DistributorCard key={d.id} d={d} index={i} />)}
        </div>
      </div>
    </section>
  );
}
